import { DataTableRequestFilter } from '~/components/acurity-table/acurity-table';
import { FilterType } from '~/components/filter/filter-options';
import { FetchUtils } from '~/utils/fetch-utils';

export class FilterUtils {
	public static computeFiltersFromParams(params: {
		[fieldName: string]: any;
	}): DataTableRequestFilter[] {
		const paramFilters: DataTableRequestFilter[] = [];
		if (params && params.filters) {
			let filtersRawObj: any[];
			try {
				filtersRawObj = JSON.parse(decodeURIComponent(params.filters));
			} catch (ex) {
				FetchUtils.logAndDisplayError('Invalid filters param');
				return [];
			}

			if (!isIterable(filtersRawObj)) {
				FetchUtils.logAndDisplayError(
					'Filters param should be in JSON array format',
				);
				return [];
			}

			let hasInvalidFilter = false;
			for (const rawFilter of filtersRawObj) {
				if (rawFilter.data === undefined) {
					hasInvalidFilter = true;
					continue;
				}
				// Declare default values for optional properties
				const {
					data,
					value,
					upperValue,
					operation = FilterType.EQUALS,
					not = false,
					ignoreCase = true,
					andJoin,
				} = rawFilter;
				if (
					!isValidFilterType(operation) ||
					!isValidBoolean(not) ||
					!isValidBoolean(ignoreCase) ||
					(!isValidBoolean(andJoin) && andJoin !== undefined)
				) {
					hasInvalidFilter = true;
					continue;
				}

				const filter: DataTableRequestFilter = {
					data,
					value,
					upperValue,
					operation,
					not,
					ignoreCase,
					andJoin,
				};
				paramFilters.push(filter);
			}

			if (hasInvalidFilter) {
				FetchUtils.logAndDisplayError(
					'One or more filters in the filters param are invalid and have been ignored',
				);
			}
		}
		return paramFilters;
	}
}

function isIterable(obj: any[]) {
	if (obj == null) {
		return false;
	}
	return typeof obj[Symbol.iterator] === 'function';
}

function isValidFilterType(operation: string): operation is FilterType {
	return Object.values(FilterType).includes(operation as FilterType);
}

function isValidBoolean(value: any) {
	return typeof value === 'boolean' || value === 'true' || value === 'false';
}
